import React from 'react';

import Button, { sizes, themes } from '../UI/Button/Button';
import { GridReveal, GridItem } from '../UI/Grid/Grid';
import Section from '../UI/Section/Section';
import Type from '../UI/Type/Type';
import * as styles from './CallToActions.module.scss';

const CTA = ({ heading, description, link }) => (
  <article className={styles.cta}>
    <Type.H2>{heading}</Type.H2>
    <p>{description}</p>
    <Button
      theme={themes.LINK}
      size={sizes.LARGE}
      to={link.url}
      target={link.target}
    >
      Learn more
    </Button>
  </article>
);

const CallToActions = ({ items, ...other }) => {
  return !items ? null : (
    <Section as="aside" {...other}>
      <GridReveal align="center" justify="center">
        {items.map((props, index) => {
          return (
            <GridItem key={index} md={6}>
              <CTA {...props} />
            </GridItem>
          );
        })}
      </GridReveal>
    </Section>
  );
};

export { CallToActions as default, CTA };
